import React from "react";
import styled, { keyframes } from "styled-components";

const bettoFadeIn = keyframes`
	from {
		opacity: 0;
		transform: scale(0.96);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
`;

const bettoShimmer = keyframes`
	0% {
		background-position: 200% 200%;
	}
	100% {
		background-position: -100% -100%;
	}
`;

const bettoTaglineIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(4px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const BettoLoaderWrap = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`;

const BettoLogoShell = styled.div`
	position: relative;
	width: ${({ $compact }) => ($compact ? "200px" : "240px")};
	height: ${({ $compact }) => ($compact ? "56px" : "68px")};
`;

const BettoLogoBase = styled.div`
	position: absolute;
	inset: 0;
	-webkit-mask: url("/loading_up.png") no-repeat center / contain;
	mask: url("/loading_up.png") no-repeat center / contain;
`;

const BettoBlueLayer = styled(BettoLogoBase)`
	background: #005cff;
	opacity: 0;
	transform: scale(0.96);
	animation: ${bettoFadeIn} 0.65s cubic-bezier(0.33, 1, 0.68, 1) forwards;
`;

const BettoShimmerLayer = styled(BettoLogoBase)`
	background: linear-gradient(
		115deg,
		transparent 0%,
		transparent 38%,
		rgba(255, 255, 255, 0.4) 50%,
		transparent 62%,
		transparent 100%
	);
	background-size: 220% 220%;
	background-repeat: no-repeat;
	animation: ${bettoShimmer} 2.4s ease-in-out 0.65s infinite;
`;

const BettoTagline = styled.p`
	margin: 0;
	font-weight: 400;
	font-size: 15px;
	line-height: 1.4;
	letter-spacing: 0.01em;
	color: rgba(217, 219, 233, 0.72);
	text-transform: none;
	opacity: 0;
	transform: translateY(4px);
	animation: ${bettoTaglineIn} 0.65s cubic-bezier(0.33, 1, 0.68, 1) 0.2s forwards;
`;

const getBettoLoadingTagline = () => {
	const lang = window.DEFAULT_LANG || "en";
	const title = window.TITLE?.[lang] || window.TITLE?.en || "";
	const tagline = (title.includes("|") ? title.split("|").slice(1).join("|") : title).trim();

	if (!tagline) {
		return "New place for betting...";
	}

	return tagline.endsWith("...") ? tagline : `${tagline.replace(/\.+$/, "")}...`;
};

export const BettoLoadingLogo = ({ showTagline = false, compact = false }) => (
	<BettoLoaderWrap>
		<BettoLogoShell $compact={compact}>
			<BettoBlueLayer />
			<BettoShimmerLayer />
		</BettoLogoShell>
		{showTagline ? <BettoTagline>{getBettoLoadingTagline()}</BettoTagline> : null}
	</BettoLoaderWrap>
);
